export class Utils {

  /* private static capitalizeKeys = (obj) => {
    const isObject = o => Object.prototype.toString.apply(o) === '[object Object]';
    const isArray = o => Object.prototype.toString.apply(o) === '[object Array]';

    let transformedObj = isArray(obj) ? [] : {};

    for (let key in obj) {
      // replace the following with any transform function
      const transformedKey = key.replace(/^\w/, (c, _) => c.to());

      if (isObject(obj[key]) || isArray(obj[key])) {
        transformedObj[transformedKey] = Utils.capitalizeKeys(obj[key]);
      } else {
        transformedObj[transformedKey] = obj[key];
      }
    }
    return transformedObj;
  } */

  public static processReturnTreeTargeting(targeting: any): Array<{ field: string, values: Array<{ label: string, id: string }> }> {
    const values: Array<{ field: string, values: Array<{ label: string, id: string }> }> = [];

    if (!targeting || targeting.length === 0) {
      return values;
    }

    targeting.forEach((x) => {
      const value = { field: x.field, values: [], id: x.id };

      x.values.forEach((y) => {
        value.values.push({ label: y.label, id: y.id });
      });

      values.push(value);
    });

    return values;
  }

  // Responsible for checking and converting the targeting model to the right Application Setting
  
  public static parseSelectedTargetingValues(targeting: any, applicationSettings: string): any[] {
    let selectedValues: any[] = [];
    if (targeting != null) {


      if (!applicationSettings) { // Old model
        if (targeting.department != null) {
          selectedValues = selectedValues.concat(targeting.department.slice());
        }
        if (targeting.custom1 != null) {
          selectedValues = selectedValues.concat(targeting.custom1.slice());
        }
        if (targeting.custom2 != null) {
          selectedValues = selectedValues.concat(targeting.custom2.slice());
        }
        if (targeting.jobTitle != null) {
          selectedValues = selectedValues.concat(targeting.jobTitle.slice());
        }
        if (targeting.location != null) {
          selectedValues = selectedValues.concat(targeting.location.slice());
        }
      } else if (applicationSettings.toLocaleLowerCase() === "user groups") {
        if (targeting.targetingGroups) {
          targeting.targetingGroups.forEach((t) => {
            selectedValues.push({Label: t, TermGuid: t, id: t });
          });
        }
      } else if (applicationSettings.toLocaleLowerCase() === "profile data") { // It is profile data
        if (targeting.targetingFields) {
          targeting.targetingFields.forEach((t) => {
            if (t.values) {
              const targetingField = t;
              targetingField.values.forEach((v) => {
                selectedValues.push({ field: targetingField.field, id: v.id, label: v.label });
              });
            }
          });
        }
      }

      return selectedValues;
    }
  }

}